<template>
  <div class="primer-acceso-page">
    <div class="pa-card">

      <!-- Ícono y cabecera -->
      <div class="pa-header">
        <div class="pa-icon-wrap">
          <i class="bi bi-shield-lock-fill"></i>
        </div>
        <h1 class="pa-title">Cambia tu contraseña</h1>
        <p class="pa-subtitle">
          Es tu primer ingreso. Por seguridad, crea una contraseña personalizada antes de continuar.
        </p>
      </div>

      <!-- Reglas -->
      <div class="pa-rules">
        <div class="rule-item" :class="{ ok: ruleLen }">
          <i :class="ruleLen ? 'bi bi-check-circle-fill' : 'bi bi-circle'"></i>
          Mínimo 8 caracteres
        </div>
        <div class="rule-item" :class="{ ok: ruleUpper }">
          <i :class="ruleUpper ? 'bi bi-check-circle-fill' : 'bi bi-circle'"></i>
          Al menos una mayúscula
        </div>
        <div class="rule-item" :class="{ ok: ruleNum }">
          <i :class="ruleNum ? 'bi bi-check-circle-fill' : 'bi bi-circle'"></i>
          Al menos un número
        </div>
      </div>

      <!-- Formulario -->
      <form @submit.prevent="cambiar" class="pa-form">

        <div class="pa-field">
          <label>Nueva contraseña</label>
          <div class="pa-input-wrap">
            <i class="bi bi-lock pa-field-icon"></i>
            <input
              :type="showNueva ? 'text' : 'password'"
              v-model="nueva"
              placeholder="••••••••"
              required
              autocomplete="new-password"
              @input="validarReglas"
            />
            <i
              :class="showNueva ? 'bi bi-eye-slash' : 'bi bi-eye'"
              class="pa-toggle"
              @click="showNueva = !showNueva"
            ></i>
          </div>
        </div>

        <div class="pa-field">
          <label>Confirmar contraseña</label>
          <div class="pa-input-wrap">
            <i class="bi bi-lock-fill pa-field-icon"></i>
            <input
              :type="showConfirm ? 'text' : 'password'"
              v-model="confirmar"
              placeholder="••••••••"
              required
              autocomplete="new-password"
            />
            <i
              :class="showConfirm ? 'bi bi-eye-slash' : 'bi bi-eye'"
              class="pa-toggle"
              @click="showConfirm = !showConfirm"
            ></i>
          </div>
          <p v-if="confirmar && nueva !== confirmar" class="pa-error">
            <i class="bi bi-exclamation-circle-fill"></i> Las contraseñas no coinciden
          </p>
        </div>

        <div v-if="errorMsg" class="pa-alert">
          <i class="bi bi-exclamation-triangle-fill"></i> {{ errorMsg }}
        </div>

        <button
          type="submit"
          class="pa-btn"
          :disabled="loading || !puedeEnviar"
        >
          <span v-if="!loading">
            <i class="bi bi-check2-circle"></i> Establecer contraseña
          </span>
          <span v-else>
            <i class="bi bi-arrow-repeat spin"></i> Guardando…
          </span>
        </button>
      </form>

      <div class="pa-brand">POSWAVE · Perdomo &amp; Asociados</div>
    </div>
  </div>
</template>

<script>
const { getApi } = require('../../config/getApiUrl.js');
import { useToast } from 'vue-toastification';
import { setPageTitle } from '@/components/pageMetadata';

export default {
  name: 'PrimerAcceso',
  data() {
    return {
      nueva: '',
      confirmar: '',
      showNueva: false,
      showConfirm: false,
      loading: false,
      errorMsg: '',
      ruleLen: false,
      ruleUpper: false,
      ruleNum: false,
    };
  },
  computed: {
    puedeEnviar() {
      return this.ruleLen && this.ruleUpper && this.ruleNum && this.nueva === this.confirmar;
    },
  },
  mounted() {
    setPageTitle('Primer acceso');
    // Si no hay marca de primer login, redirigir
    if (!localStorage.getItem('primer_login')) {
      const role = localStorage.getItem('role');
      this.$router.replace(role === '3' ? '/ventas' : '/home');
    }
  },
  methods: {
    validarReglas() {
      this.ruleLen   = this.nueva.length >= 8;
      this.ruleUpper = /[A-Z]/.test(this.nueva);
      this.ruleNum   = /[0-9]/.test(this.nueva);
    },
    async cambiar() {
      this.errorMsg = '';
      if (!this.puedeEnviar) return;

      const token = localStorage.getItem('auth');
      if (!token) { this.$router.push('/login'); return; }

      this.loading = true;
      try {
        const res = await fetch(`${getApi()}/primer-acceso`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            contraseña_nueva:   this.nueva,
            contraseña_confirm: this.confirmar,
          }),
        });

        const data = await res.json();

        if (res.ok) {
          localStorage.removeItem('primer_login');
          const toast = useToast();
          toast.success('¡Contraseña actualizada! Bienvenido al sistema.', { timeout: 3000 });
          const role = localStorage.getItem('role');
          await this.$router.push(role === '3' ? '/ventas' : '/home');
        } else {
          this.errorMsg = data.message || 'Error al actualizar la contraseña.';
        }
      } catch {
        this.errorMsg = 'Error de conexión. Intenta de nuevo.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.primer-acceso-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-main, #f4f4f6);
  padding: 24px 16px;
}

.pa-card {
  width: 100%;
  max-width: 440px;
  background: var(--surface-1, #fff);
  border: 1px solid var(--border, #e5e5e5);
  border-radius: 16px;
  padding: 40px 36px;
  box-shadow: 0 8px 32px rgba(0,0,0,.07);
}

/* ── Cabecera ── */
.pa-header { text-align: center; margin-bottom: 28px; }

.pa-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px; height: 64px;
  border-radius: 50%;
  background: rgba(192,157,98,.12);
  margin-bottom: 16px;
}
.pa-icon-wrap i { font-size: 28px; color: #c09d62; }

.pa-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--text-main, #1a1a1a);
  margin: 0 0 8px;
}
.pa-subtitle {
  font-size: .855rem;
  color: var(--text-muted, #666);
  line-height: 1.5;
  margin: 0;
}

/* ── Reglas de contraseña ── */
.pa-rules {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 24px;
  padding: 14px 16px;
  background: var(--surface-2, #f8f8f8);
  border: 1px solid var(--border, #e5e5e5);
  border-radius: 10px;
}
.rule-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: .8rem;
  color: var(--text-muted, #999);
  transition: color .2s;
}
.rule-item.ok { color: #4ade80; font-weight: 600; }
.rule-item i { font-size: .9rem; flex-shrink: 0; }

/* ── Formulario ── */
.pa-form { display: flex; flex-direction: column; gap: 18px; }

.pa-field { display: flex; flex-direction: column; gap: 6px; }
.pa-field label { font-size: .82rem; font-weight: 600; color: var(--text-main, #222); }

.pa-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.pa-input-wrap input {
  width: 100%;
  padding: 10px 40px 10px 38px;
  border: 1.5px solid var(--border, #ddd);
  border-radius: 9px;
  font-size: .9rem;
  background: var(--surface-1, #fff);
  color: var(--text-main, #222);
  outline: none;
  transition: border-color .2s;
  box-sizing: border-box;
}
.pa-input-wrap input:focus { border-color: #c09d62; }
.pa-field-icon {
  position: absolute;
  left: 12px;
  color: var(--text-muted, #999);
  font-size: .95rem;
  pointer-events: none;
}
.pa-toggle {
  position: absolute;
  right: 12px;
  color: var(--text-muted, #999);
  cursor: pointer;
  font-size: .95rem;
  user-select: none;
}

.pa-error {
  font-size: .78rem;
  color: #f87171;
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 0;
}

.pa-alert {
  padding: 12px 14px;
  border-radius: 8px;
  background: rgba(248,113,113,.1);
  border: 1.5px solid rgba(248,113,113,.3);
  color: #f87171;
  font-size: .83rem;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ── Botón ── */
.pa-btn {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 10px;
  background: #c09d62;
  color: #fff;
  font-size: .95rem;
  font-weight: 700;
  cursor: pointer;
  transition: background .2s, opacity .2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.pa-btn:hover:not(:disabled) { background: #a88450; }
.pa-btn:disabled { opacity: .55; cursor: not-allowed; }

/* ── Branding ── */
.pa-brand {
  text-align: center;
  margin-top: 28px;
  font-size: .72rem;
  color: var(--text-soft, #bbb);
  letter-spacing: .5px;
}

/* ── Spinner ── */
.spin { display: inline-block; animation: spin .8s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }

/* ── Dark mode ── */
@media (prefers-color-scheme: dark) {
  :root:not([data-theme="light"]) .primer-acceso-page { background: #0f0f0f; }
  :root:not([data-theme="light"]) .pa-card { background: #1a1a1a; border-color: #2a2a2a; }
}
:root[data-theme="dark"] .primer-acceso-page { background: #0f0f0f; }
:root[data-theme="dark"] .pa-card { background: #1a1a1a; border-color: #2a2a2a; }
</style>
